import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { ApprovalWorkflowSettings } from '.'

export const approvalWorkflowSettingsQuery = gql`
  query ApprovalWorkflowSettings($organizationID: ID!) {
    approvalWorkflowSettings(organizationID: $organizationID) {
      enabled
      statuses
      severities
    }
  }
`

export interface ChildProps {
  readonly settings: ApprovalWorkflowSettings
  readonly refetch: () => Promise<any>
}

interface Props {
  readonly organizationID: string
  readonly children: (props: ChildProps) => React.ReactNode
}

export function ApprovalWorkflowSettingsLoader({
  organizationID,
  children
}: Props) {
  return (
    <Query
      query={approvalWorkflowSettingsQuery}
      variables={{ organizationID }}
      errorPolicy="all"
    >
      {(result) => {
        const { data, error, refetch } = result
        if (error) {
          throw new Error(error.message)
        }

        const workflowEnabled =
          !!data && !!data.approvalWorkflowSettings
            ? data.approvalWorkflowSettings.enabled
            : false

        const settings: ApprovalWorkflowSettings = {
          workflowEnabled,
          statuses: workflowEnabled
            ? data.approvalWorkflowSettings.statuses
            : [],
          severities: workflowEnabled
            ? data.approvalWorkflowSettings.severities
            : []
        }

        return children({
          settings,
          refetch
        })
      }}
    </Query>
  )
}
